<template>
    <div  :class="{'showright':type,'showwrong':!type}">
        {{order}}
    </div>
</template>
<script>
export default {
    name:"showright",
    props:['type','order']
}
</script>
<style lang="css" scoped>
.showright{
    display: inline-block;
    width:0.33rem;
    height: 0.33rem;
    border-radius: 3px;
    background: url('../assets/icons/right.png') no-repeat center center;
    background-size: 100% 100%;
    text-align: center;
    line-height: 0.33rem;
    font-size: 0.14rem;
    font-weight: bold;
    color: #1dd05c;
    margin: 0.1rem 0.2rem 0.1rem 0;
}
.showwrong{
    display: inline-block;
    width:0.33rem;
    height: 0.33rem;
    border-radius: 3px;
    background: url('../assets/icons/wrong.png') no-repeat center center;
    background-size: 100% 100%;
    text-align: center;
    line-height: 0.33rem;
    font-size: 0.14rem;
    font-weight: bold;
    color: #ff064e;
    margin: 0.1rem 0.2rem 0.1rem 0;
}
    
</style>


// WEBPACK FOOTER //
// src/components/showright.vue